import React from "react";

const Loader = () => {
  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50 backdrop-blur">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
